import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import theme from './styles/theme';
import AuthProvider from './contexts/AuthContext';
import { ThemeSettingsProvider } from './contexts/ThemeContext';
import { TaskProvider } from './contexts/TaskContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Logout from './components/auth/Logout';
import LoginPage from './pages/auth/LoginPage';
import SuperAdminDashboard from './pages/super-admin/Dashboard';
import DealerDashboard from './pages/dealer-admin/Dashboard';
import UserManagement from './pages/super-admin/UserManagement';
import DealerManagement from './pages/super-admin/DealerManagement';
import NewAnalysis from './pages/dealer-admin/NewAnalysis';
import Uploads from './pages/super-admin/Uploads';
import Monitor from './pages/super-admin/Monitor';
import TechConsole from './pages/master-admin/TechConsole';
import CredentialsVault from './pages/master-admin/CredentialsVault';
import PerformanceDiagnostics from './pages/master-admin/PerformanceDiagnostics';
import LiveActivityMonitor from './pages/master-admin/LiveActivityMonitor';

import BulkUpload from './pages/dealer-admin/BulkUpload';
import Results from './pages/dealer-admin/Results';
import DealerUsers from './pages/dealer-admin/Users';
import AccountProfile from './pages/dealer-admin/AccountProfile';
import ChangePassword from './pages/dealer-admin/ChangePassword';
import SupportPage from './pages/SupportPage';
import ThemeSettings from './pages/config/ThemeSettings';
import CitNowUpgrades from './pages/CitNowUpgrades';
import GlobalTaskNotification from './components/common/GlobalTaskNotification';
import TechLuxuryDashboard from './pages/master-admin/TechLuxuryDashboard';
import Presentation from './pages/Presentation';
import { useAuth } from './contexts/AuthContext';

export default function App() {
  return (
    <AuthProvider>
      <ThemeSettingsProvider>
        <CssBaseline />
        <TaskProvider>
          <Routes>
            <Route path="/presentation" element={<Presentation />} />
            <Route path="/portal" element={<Presentation />} />
            <Route path="/showcase" element={<Presentation />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<Logout />} />

            {/* Shared Configuration Routes (all authenticated roles) */}
            <Route element={<ProtectedRoute roles={["super_admin", "master_admin", "dealer_admin", "dealer_user", "branch_admin"]} />}>
              <Route path="/config" element={<Navigate to="/config/theme" replace />} />
              <Route path="/config/theme" element={<Layout><ThemeSettings /></Layout>} />
              <Route path="/super-admin/config" element={<Navigate to="/config/theme" replace />} />
              <Route path="/citnow-upgrades" element={<Layout><CitNowUpgrades /></Layout>} />
            </Route>

            {/* Super Admin Routes */}
            <Route element={<ProtectedRoute roles={["super_admin"]} />}>
              <Route path="/super-admin/dashboard" element={<Layout><SuperAdminDashboard /></Layout>} />
              <Route path="/super-admin/monitor" element={<Layout><Monitor /></Layout>} />
              <Route path="/super-admin/uploads" element={<Layout><Uploads /></Layout>} />
              <Route path="/super-admin/users" element={<Layout><UserManagement /></Layout>} />
              <Route path="/super-admin/dealers" element={<Layout><DealerManagement /></Layout>} />
            </Route>

            {/* Master Admin Only Routes (Tech Console, Vault, Live Activity, Diagnostics) */}
            <Route element={<ProtectedRoute roles={["master_admin"]} />}>
              <Route path="/master-admin/console" element={<Layout><TechConsole /></Layout>} />
              <Route path="/master-admin/credentials" element={<Layout><CredentialsVault /></Layout>} />
              <Route path="/master-admin/performance" element={<Layout><PerformanceDiagnostics /></Layout>} />
              <Route path="/super-admin/performance" element={<Layout><PerformanceDiagnostics /></Layout>} />
              <Route path="/master-admin/live" element={<Layout><LiveActivityMonitor /></Layout>} />
              <Route path="/super-admin/live" element={<Layout><LiveActivityMonitor /></Layout>} />
            </Route>

            {/* Link Analysis & Optimization (Accessible to Super Admin & Dealer roles) */}
            <Route element={<ProtectedRoute roles={["super_admin", "dealer_admin", "dealer_user", "branch_admin"]} />}>
              <Route path="/dealer/new" element={<Layout><NewAnalysis /></Layout>} />
              <Route path="/dealer/bulk" element={<Layout><BulkUpload /></Layout>} />
              <Route path="/dealer/results" element={<Layout><Results /></Layout>} />
            </Route>

            <Route element={<ProtectedRoute roles={["dealer_admin", "dealer_user", "branch_admin"]} />}>
              <Route path="/dealer/dashboard" element={<Layout><DealerDashboard /></Layout>} />
              <Route path="/dealer/users" element={<Layout><DealerUsers /></Layout>} />
              <Route path="/support" element={<Layout><SupportPage /></Layout>} />
            </Route>

            <Route element={<ProtectedRoute roles={["super_admin", "dealer_admin", "dealer_user", "branch_admin"]} />}>
              <Route path="/account/profile" element={<Layout><AccountProfile /></Layout>} />
              <Route path="/account/password" element={<Layout><ChangePassword /></Layout>} />
            </Route>



            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <GlobalTaskNotification />
        </TaskProvider>
      </ThemeSettingsProvider>
    </AuthProvider>
  );
}


